// eslint-disable-next-line no-multi-assign
const fetchExports = module.exports = require('./fetch.js');
fetchExports.fetchJSON = require('./fetchJSON.js');
fetchExports.fetchCompositeJSON = require('./fetchCompositeJSON.js');
